export const searchKeywordSelector = (state) => state.search?.searchKeyword;
export const searchTypeSelector = (state) => state.search?.searchType;
